"use strict";
(function(){
	const waitForElement = () => {
		if(!!window.VariantSwatchKing){
            // console.log("VariantSwatchKing loaded");

            setTimeout(function() {
              if($(".swatch-view-item").length > 0) {
                $(".swatch-view-item").each(function() {
                    $(this).attr("title", $(this).attr("orig-value"));   
                });
              }
            }, 1000);
          
		} else {
			requestAnimationFrame(waitForElement);
		}
	};
	waitForElement();
})();